/**
 * RBAC Types — Mirror of backend Role & Permission enums.
 */

export enum Role {
  ADMIN = 'admin',
  DIRECTION = 'direction',
  DIR_COMMERCIAL = 'dir_commercial',
  RESPONSABLE_PIO = 'responsable_pio',
  PIO = 'pio',
  COMMERCIAL = 'commercial',
}

export const ROLE_LABELS: Record<Role, string> = {
  [Role.ADMIN]: 'Administrateur',
  [Role.DIRECTION]: 'Direction',
  [Role.DIR_COMMERCIAL]: 'Dir. Commercial',
  [Role.RESPONSABLE_PIO]: 'Responsable PIO',
  [Role.PIO]: 'PIO',
  [Role.COMMERCIAL]: 'Commercial',
};

export const ROLE_LEVELS: Record<Role, number> = {
  [Role.ADMIN]: 6,
  [Role.DIRECTION]: 5,
  [Role.DIR_COMMERCIAL]: 4,
  [Role.RESPONSABLE_PIO]: 3,
  [Role.PIO]: 2,
  [Role.COMMERCIAL]: 1,
};

export enum Permission {
  // Candidats
  CANDIDATES_VIEW = 'candidates:view',
  CANDIDATES_EXPORT = 'candidates:export',
  // Coordonnées et souhaits du consultant (matching inversé) — même droit côté backend.
  CANDIDATES_EDIT_CONTACT = 'candidates:edit_contact',

  // Offres
  OFFERS_VIEW = 'offers:view',
  OFFERS_CREATE = 'offers:create',
  OFFERS_UPDATE = 'offers:update',
  OFFERS_ASSIGN_COMMERCIAL = 'offers:assign_commercial',
  OFFERS_MANAGE_CANDIDATES = 'offers:manage_candidates',

  // CRM
  CRM_VIEW = 'crm:view',
  CRM_MOVE_CANDIDATE = 'crm:move_candidate',
  CRM_ADD_ACTIVITY = 'crm:add_activity',
  CRM_DASHBOARD = 'crm:dashboard',
  CRM_PIPELINE_MY = 'crm:pipeline_my',
  CRM_UPDATE_NOTES = 'crm:update_notes',
  CRM_EXCLUDE_CANDIDATE = 'crm:exclude_candidate',
  CRM_OFFER_STATUS = 'crm:offer_status',
  CRM_COMMENTS = 'crm:comments',

  // Rappels
  REMINDERS_MANAGE = 'reminders:manage',
  REMINDERS_TODAY_ACTIONS = 'reminders:today_actions',

  // Analytics
  ANALYTICS_CANDIDATES = 'analytics:candidates',
  ANALYTICS_OFFERS = 'analytics:offers',
  ANALYTICS_TRENDS = 'analytics:trends',
  ANALYTICS_SKILLS_GAP = 'analytics:skills_gap',
  ANALYTICS_ENRICHMENTS = 'analytics:enrichments',
  ANALYTICS_CONTRIBUTORS = 'analytics:contributors',
  ANALYTICS_SYNC_STATUS = 'analytics:sync_status',
  CRM_ANALYTICS_FUNNEL = 'crm:analytics_funnel',

  // Favoris / Recherches
  FAVORITES_MANAGE = 'favorites:manage',
  SAVED_SEARCHES_MANAGE = 'saved_searches:manage',

  // CV
  CV_UPLOAD = 'cv:upload',
  CV_DOWNLOAD = 'cv:download',
  CV_DELETE = 'cv:delete',

  // Clients
  CLIENTS_VIEW = 'clients:view',
  CLIENTS_MANAGE = 'clients:manage',

  // Referentiel
  LOCATIONS_VIEW = 'locations:view',
  SKILLS_VIEW = 'skills:view',
  AUTOCOMPLETE_VIEW = 'autocomplete:view',
  SUGGESTIONS_VIEW = 'suggestions:view',
  STATISTICS_VIEW = 'statistics:view',

  // Admin
  ADMIN_ES_MANAGEMENT = 'admin:es_management',
  ADMIN_MONITORING = 'admin:monitoring',

  // Référentiel de compétences
  REFERENTIEL_VIEW = 'referentiel:view',
  REFERENTIEL_EDIT = 'referentiel:edit',
}
